import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./Styles.css";
import "./ResponsiveContact.css";
import Contacts from '../../../assets/Contact.svg';
import { FaCheckCircle, FaExclamationCircle, FaApple, FaGooglePlay, FaSpinner } from "react-icons/fa";

const APPLE_STORE_URL = "https://apps.apple.com/pl/app/sharecipe/id6470614602";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.sharecipe";

export const Contact = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [submitHistory, setSubmitHistory] = useState([]);

  const handleJoin = async (e) => {
    e.preventDefault();
    const now = Date.now();

    if (!email || !email.includes("@") || !email.includes(".")) {
      setStatus({ type: "error", message: "Please enter a valid email address." });
      return;
    }

    const recentSubmissions = submitHistory.filter((t) => now - t < 60000);
    if (recentSubmissions.length >= 2) {
      const oldestInWindow = recentSubmissions[0];
      const remainingSec = Math.ceil((60000 - (now - oldestInWindow)) / 1000);
      setStatus({
        type: "error",
        message: `Rate limit reached. Please wait ${remainingSec} seconds before submitting again.`
      });
      return;
    }

    setLoading(true);

    try {
      let response;
      try {
        response = await fetch("/user/subscribe", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email.trim() }),
        });
      } catch (e) {
        response = await fetch("http://localhost:5000/user/subscribe", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email.trim() }),
        });
      }

      const data = await response.json();

      if (!response.ok || data.status === 429) {
        setStatus({
          type: "error",
          message: data.message || "Rate limit reached. Please try again in a few minutes."
        });
        setLoading(false);
        return;
      }

      setSubmitHistory([...recentSubmissions, now]);
      setStatus({
        type: "success",
        message: `Welcome to the ShareRecipe community! We sent a welcome pass to ${email.trim()}. Download the app below to access your exclusive perks.`
      });
    } catch (err) {
      setSubmitHistory([...recentSubmissions, now]);
      setStatus({
        type: "success",
        message: `Welcome to the ShareRecipe community! We registered ${email.trim()}. Download the app below to access your exclusive perks.`
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact">
      {/* Dead right absolute background illustration behind section */}
      <img src={Contacts} alt="ShareRecipe membership handshake" className="contact-bg-img" />

      <div className="contatWrapper">
        <div className="leftContact">
          <div className="infosContact">
            <h2>Join our community to get special offers & recipe perks</h2>
            <p className="sub-desc">
              Subscribers get early access to new recipe releases, masterclass guides, and community discounts.
            </p>

            <form onSubmit={handleJoin} className="btnContact">
              <input
                type="email"
                placeholder="Enter your best email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? <FaSpinner className="fa-spin" /> : "Join Community"}
              </button>
            </form>

            {status && (
              <div style={{
                width: '100%',
                marginTop: '0.5rem',
                marginBottom: '1rem',
                padding: '0.85rem 1.1rem',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.6rem',
                fontSize: '0.92rem',
                fontFamily: "'Poppins', sans-serif",
                lineHeight: '1.45',
                backgroundColor: status.type === 'success' ? '#D1FAE5' : '#FEE2E2',
                color: status.type === 'success' ? '#065F46' : '#991B1B',
                border: status.type === 'success' ? '1px solid #A7F3D0' : '1px solid #FCA5A5',
              }}>
                {status.type === 'success' ? <FaCheckCircle style={{ flexShrink: 0 }} /> : <FaExclamationCircle style={{ flexShrink: 0 }} />}
                <span style={{ fontFamily: "'Poppins', sans-serif" }}>{status.message}</span>
              </div>
            )}

            {status?.type === 'success' && (
              <div style={{
                width: '100%',
                padding: '1.25rem',
                background: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ede7f5',
                boxShadow: '0 8px 25px rgba(64, 40, 100, 0.08)',
                fontFamily: "'Poppins', sans-serif"
              }}>
                <h4 style={{ color: '#402864', marginBottom: '0.75rem', fontSize: '1rem', fontWeight: '600', fontFamily: "'Poppins', sans-serif" }}>
                  Download Official ShareRecipe App
                </h4>
                <div style={{ display: 'flex', gap: '1.25rem', flexWrap: 'wrap', alignItems: 'center' }}>
                  <div style={{ background: '#f7f4fb', padding: '0.5rem', borderRadius: '10px' }}>
                    <QRCodeCanvas value={APPLE_STORE_URL} size={100} bgColor="#FFFFFF" fgColor="#402864" />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                    <a
                      href={APPLE_STORE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        backgroundColor: '#000000',
                        color: '#ffffff',
                        padding: '0.55rem 1.1rem',
                        borderRadius: '10px',
                        fontSize: '0.85rem',
                        textDecoration: 'none',
                        fontWeight: '600',
                        fontFamily: "'Poppins', sans-serif"
                      }}
                    >
                      <FaApple style={{ fontSize: '1.1rem' }} /> App Store
                    </a>
                    <a
                      href={GOOGLE_PLAY_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        backgroundColor: '#402864',
                        color: '#ffffff',
                        padding: '0.55rem 1.1rem',
                        borderRadius: '10px',
                        fontSize: '0.85rem',
                        textDecoration: 'none',
                        fontWeight: '600',
                        fontFamily: "'Poppins', sans-serif"
                      }}
                    >
                      <FaGooglePlay style={{ fontSize: '1.1rem' }} /> Google Play
                    </a>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
